module.exports = __webpack_public_path__ + "static/media/our-aim.c9076646.jpg";